<ng-container *transloco="let t; read: 'bye'">
  <div class="p-d-flex p-flex-column p-jc-center p-ai-center" style="height: 100vh;">
    <p class="ondark p-text-center"><fa-icon class="p-pb-4 icon" [icon]="faUserLock"></fa-icon></p>
    <h1 class="p-text-center">{{ t('title') }}</h1>
    <p class="ondark p-text-center">{{ t('logged_out') }}</p>
  </div>
</ng-container>
